import { Repository } from "./adapters/repository";

import * as retrieveDiscussion from "./useCases/retrieveDiscussion";
import * as postComment from "./useCases/postComment";
import * as removeComment from "./useCases/removeComment";
import * as retrieveDiscussions from "./useCases/retrieveDiscussions";
import * as startDiscussion from "./useCases/startDiscussion";
import * as removeDiscussion from "./useCases/removeDiscussion";

enum UseCases {
  retrieveDiscussion = "retrieveDiscussion",
  postComment = "postComment",
  removeComment = "removeComment",
  retrieveDiscussions = "retrieveDiscussions",
  startDiscussion = "startDiscussion",
  removeDiscussion = "removeDiscussion",
}

interface Core {
  [UseCases.retrieveDiscussion]: retrieveDiscussion.Interactor;
  [UseCases.postComment]: postComment.Interactor;
  [UseCases.removeComment]: removeComment.Interactor;
  [UseCases.retrieveDiscussions]: retrieveDiscussions.Interactor;
  [UseCases.startDiscussion]: startDiscussion.Interactor;
  [UseCases.removeDiscussion]: removeDiscussion.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveDiscussion]: retrieveDiscussion.createInteractor(
      dependencies.repository,
    ),
    [UseCases.postComment]: postComment.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeComment]: removeComment.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveDiscussions]: retrieveDiscussions.createInteractor(
      dependencies.repository,
    ),
    [UseCases.startDiscussion]: startDiscussion.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeDiscussion]: removeDiscussion.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
